import { render } from "./KskModalShell.vue?vue&type=template&id=092e1bb5&scoped=true"
import script from "./KskModalShell.vue?vue&type=script&lang=js"
export * from "./KskModalShell.vue?vue&type=script&lang=js"

import "./KskModalShell.vue?vue&type=style&index=0&id=092e1bb5&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092e1bb5"]])

export default __exports__